import type {AddComponentTypeOptions} from 'grapesjs';
import {FORM_DESCRIPTION_TEXT_STYLES} from '@FormMakerReact/components/component-styles';

export const POSTERMYWALL_DESCRIPTION_TEXT_TYPE = 'postermywall-description-text';

const DESCRIPTION_DATA_ATTR = 'data-is-pmw-form-description';

export const POSTERMYWALL_DESCRIPTION_TEXT: AddComponentTypeOptions = {
  extend: 'text',
  isComponent: (el: HTMLElement) => {
    if (typeof el.getAttribute !== 'function') {
      return undefined;
    }
    if (!el.getAttribute(DESCRIPTION_DATA_ATTR)) {
      return undefined;
    }
    return {type: POSTERMYWALL_DESCRIPTION_TEXT_TYPE};
  },
  model: {
    defaults: {
      tagName: 'p',
      name: window.i18next.t('pmwjs_form_maker_description'),
      icon: 'icon-text',
      stylable: true,
      highlightable: true,
      hoverable: true,
      selectable: true,
      editable: true,
      copyable: false,
      removable: false,
      badgable: true,
      draggable: false,
      toolbar: [],
      content: window.i18next.t('pmwjs_form_maker_default_description'),
      attributes: {
        'data-pmw-type': POSTERMYWALL_DESCRIPTION_TEXT_TYPE,
        [DESCRIPTION_DATA_ATTR]: '1',
      },
      style: FORM_DESCRIPTION_TEXT_STYLES,
    },
  },
};
